import { styled } from '@mui/material'
import Button from '@mui/material/Button'

const StyledButton = styled(Button)(({ theme, size }) => ({
  padding: size === 'small' ? '0.7rem 1.6rem' : null,
  backgroundColor: theme.vars.palette.primary.main,
  color: theme.vars.palette.text.contrast,
  '&:hover': {
    backgroundColor: theme.vars.palette.primary.light,
  },
  '&:active': {
    backgroundColor: theme.vars.palette.primary.dark2,
  },
  '&:disabled': {
    backgroundColor: theme.vars.palette.secondary.main,
  },
}))

function ButtonPrimary(props) {
  const { children } = props

  return <StyledButton {...props}>{children}</StyledButton>
}

export default ButtonPrimary
